import { render, staticRenderFns } from "./scene12.vue?vue&type=template&id=3ec7dd56&scoped=true&"
import script from "./scene12.vue?vue&type=script&lang=ts&"
export * from "./scene12.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec7dd56",
  null
  
)

export default component.exports